import { Component, OnInit, EventEmitter, HostListener } from '@angular/core';
import { serviceConstants } from 'src/app/constants/service.constants';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from '../../../services/user.service';
import { DateObject, Document_Upload_File, ModuleMenu, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { FileService } from 'src/app/services/file.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-ist-general-information',
  templateUrl: './ist-general-information.component.html',
  styleUrls: ['./ist-general-information.component.scss']
})
export class IstGeneralInformationComponent implements OnInit, IDeactivateComponent {

  staticformFields: any = [];
  uploadInput: EventEmitter<any>;
  dragOver: boolean;
  status : number = 0;
  submit_status : number = 0;
  user : any
  IsRecordSaved:boolean = false;
  Id : string
  ApplicationID: any;
  isSubmitVisible : boolean = false;
  menudata: ModuleMenu;
  permission: string = "";
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  IsFormToched: boolean = false;
  tooltipValue: any;
  Application_Type_ID: string = "";
  isDateModified: boolean = false;
  Full_Date: DateObject;
  submittedresponse: SCREEN_RESPONSE[] = [];
  ModelData: any = null;
  SCREEN_MODEL: any = null;
  ISTapp: any;
  createdUser: any;
  disableSave: boolean = false;
  ScreenSubmitStatus: boolean = false;
  ScreenName: string="";
  Currency_ID: string = "";
  
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private summaryService: IstSummaryService,
    private DatashareSerivce: IstDataShareService,
    public commonService: CommonService,
    private userService: UserService,
    public fileService: FileService,
    public datepipe: DatePipe
  ) {
    this.uploadInput = new EventEmitter<any>();
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    this.permission = this.commonService.getPagePermission("IST01").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("IST01").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
           clearInterval(intervalId);
            this.setFormPermissions();
         }
       }, 1000);
   }
   else{
    this.setFormPermissions();
   }

    this.DatashareSerivce.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      this.GetScreenConfigControls('SCR-001');
    });
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.DatashareSerivce.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.DatashareSerivce.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.ISTapp = this.commonService.getISTApp();
    this.user = this.userService.getUserDetais();
    this.userType = this.userService.getUserType();
    if(!this.isSubmitVisible){
      this.disableSave = false;
    }
  }
 
  getScreenDataEdit() {
    this.summaryService.getGeneralInformation("api/ISTGeneralInfo/GetMasterList?ApplicationID=" + this.ApplicationID).subscribe((summary) => {
      if (summary != null && summary != undefined) {        
        this.createdUser = summary["RECORD_CREATED_BY"];
        this.status = summary["STATUS"];
        if(summary["RECORD_CREATED_BY"] == null){
          this.IsRecordSaved = false;
        }
        else{
          this.IsRecordSaved = true;
        }
        if((summary["SUBMIT_STATUS"] == 1) || (this.user.ID == summary["RECORD_CREATED_BY"]) || this.isSubmitVisible == false){
          this.Id = summary["ID"];
          
          this.ModelData = summary;
       
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(summary);
          this.ScreenSubmitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
          if(this.ScreenSubmitStatus){
            this.disableSave = true;
          }
          if(!this.isSubmitVisible){
            this.disableSave = false;
          }
        } 
      }
    });
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-001";
      sr.RowId = this.ApplicationID;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }
  BindDataToStaticControls(MainObjData: any): any {
    for (var i = 0; i < this.staticformFields.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "TITLE_OF_STUDY":
          this.staticformFields[i].ControlValue = MainObjData.TITLE_OF_STUDY;
          break;
        case "STUDY_SPONSORED":
          this.staticformFields[i].ControlValue = MainObjData.STUDY_SPONSORED;
          break;
        case "THERAPEUTIC_AREA_ID":
          this.staticformFields[i].ControlValue = MainObjData.THERAPEUTIC_AREA_ID;
          break;
        case "REQUEST_TYPE":
          this.staticformFields[i].ControlValue = MainObjData.REQUEST_TYPE;
          this.requestTypeSelectionChanged(MainObjData.REQUEST_TYPE,this.staticformFields[i]);
          break;
        case "PRODUCTIDS":
          this.staticformFields[i].ControlValue=[];
          if(MainObjData.PRODUCTIDS)
          {
             let ids=MainObjData.PRODUCTIDS.split(",");
             ids.forEach((item:any)=>{
              this.staticformFields[i].ControlValue.push(item);
             });
          }
          else{
            this.staticformFields[i].ControlValue =[];
          }
          break;
        case "HAS_OTHER_COMPOUNDS":
          this.staticformFields[i].ControlValue = MainObjData.HAS_OTHER_COMPOUNDS;
          break;
        case "OTHER_COMPOUNDS_DETAILS":
          this.staticformFields[i].ControlValue = MainObjData.OTHER_COMPOUNDS_DETAILS;
          break;
        case "STUDY_TYPE":
          this.staticformFields[i].ControlValue = MainObjData.STUDY_TYPE;
          break;
        case "IS_MULTI_CENTER_INVOLVED":
          this.staticformFields[i].ControlValue = MainObjData.IS_MULTI_CENTER_INVOLVED;
          break;
        case "IB":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "IB"
          });
          break;
        case "FDA1571":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "FDA1571"
          });
          break;
        case "FDA1572":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "FDA1572"
          });

          break;
        case "IRB":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "IRB"
          });
          break;
        case "ICDOC":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "ICDOC"
          });
          break;
        case "IGSS":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "IGSS"
          });
          break;
        case "SC":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SC"
          });
          break;
        case "IS":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "IS"
          });
          break;
        case "COI":
          this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "COI"
          });
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }

  private setFormPermissions() {
    if (this.permission == "view") {
      this.operations = [];
    }
    else {
      this.operations = [
        { name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this }
      ]
    }

  }
  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID,(ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.ScreenName = this.SCREEN_MODEL?.NAME;
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.getScreenDataEdit();
      if(this.ISTapp!=null && this.ISTapp.STATUS > 1){
        this.isSubmitVisible = ScreenData.HAS_SAVE_SUBMIT == 1 ? true :false;       
      }     
    });
  }

  SaveGeneralInfo(SaveType : string) {
   
    if(this.IsRecordSaved && this.user.ID != this.createdUser && this.ScreenSubmitStatus==false){      
      return this.commonService.ValidationBanner("This screen is currently being worked on by another user. You are not permitted to make changes at this time.");
    }

    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();
        //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        let FinalControls = _.cloneDeep(this.staticformFields);
        FinalControls.forEach((item) => {
          switch (item.CONTROL) {
            case 10:
              item.ControlValue = null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("Appid", this.ApplicationID);
        uploadData.append("ModuleID", "2");
        uploadData.append("IS_RequestFromGeneralInfo", "Y");
        if (SaveType == "Save") {
          if(this.isSubmitVisible == true && this.ISTapp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
            uploadData.append("SUBMIT_STATUS", "0");

          } 
          else {
            uploadData.append("SUBMIT_STATUS", "1");
          }
        } else{
          uploadData.append("SUBMIT_STATUS", "1");

        }

        if (this.ApplicationID == "" || this.ApplicationID == undefined) {
          uploadData.append("Application_Type_ID", this.Application_Type_ID);
           uploadData.append("Currency_ID", this.Currency_ID);
          this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData).subscribe((result) => {
            this.IsFormToched = false;
            this.ApplicationID = result["TransactionID"];
            this.DatashareSerivce.setApplicationID(this.ApplicationID);
            if (result.Status === 0) {
              this.getScreenDataEdit();
              this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
              this.commonService.refreshPage(this.ApplicationID);
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Update", uploadData).subscribe((result) => {
            this.IsFormToched = false;
            if (result.Status === 0) {
              if (result.ErrorCode === "NOCHANGES") {
                this.getScreenDataEdit();
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.getScreenDataEdit();
                this.commonService.SuccessBanner(this.ScreenName + " updated successfully");
              }
            }
            else {
              this.getScreenDataEdit();
              this.commonService.ValidationBanner(result.Message);
            }
          });
        
        }
      }
    }
  }

  
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    if(this.status > 1){
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 10:
                if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if(!item.ControlValue)
              {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
      });

      if (isValid) {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (!inactiveValueControls || inactiveValueControls.length == 0) {
        }
        else {
          isValid=false;
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }
    }
    else{
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter at least one field. <br/>`;
      }
    }
    if (!isValid)
      this.commonService.ValidationBanner(message);
   
   
    return isValid;
  }

  canExit() {
    if (this.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }
  uploadchange(event, ques: SCREEN_CONTROL): void {
    //let Flag = true;
    let Isexe = false;
    let Is500MB = false;
    let IscrdDownload = false;

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      // else if (file != null && ((filesize > 524288000))) {
      //   Is500MB = true;
      // }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is500MB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 500MB");
    }

    else if (Is500MB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }
  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  
  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
    if(question.FIELD_CODE=="REQUEST_TYPE"){
      this.requestTypeSelectionChanged($event.value,question);
    }
  }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display==false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if(con.CONTROL == "6"){
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display==true) {
          
        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if(con.CONTROL == "6")
            {
              con.SourceItems.forEach((item) => {
                item.Checked = false;
              });
            }
        }
        if (con.IS_Dependent_Enabled == true) {
         
        }
      });
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }
  requestTypeSelectionChanged(selectedValue: any, RequestTypeControl: SCREEN_CONTROL) {
    const reqType = RequestTypeControl.GROUP_VALUES_LIST.find((x: any) => x.value ==selectedValue)
    if (reqType != null && ((reqType.label.toLowerCase().indexOf('product') > -1) || (reqType.label.toLowerCase().indexOf('both') > -1))) {
      this.staticformFields.forEach((item)=>{
        if(item.FIELD_CODE=="PRODUCTIDS"){
          item.IS_Dependent_Display=true;
        }
      });
    }
    else{
     this.staticformFields.forEach((item)=>{
        if(item.FIELD_CODE=="PRODUCTIDS"){
          item.IS_Dependent_Display=false;
        }
      });
    }
  }
}
